<div style="display: flex; flex-direction: column; align-items: flex-start;background-color: #000;padding:24px"
  class="permission_container">
  <div style="padding-bottom: 20px">
    <h4 style="margin-top: 0;font-size: 18px;">Project status</h4>
    <div class="btn-list mt_50">
      <button *ngFor="let status of statuses" mat-button [class]="{'disabled': project.status == status.id}"
      [disabled]="status.id === -1"
        [class.declicked]="status.id === -1" (click)="changeStatus(status.id)">{{status.name}}</button>
    </div>

    <!-- <form [formGroup]="statusForm" style="display: flex; flex-direction: column">
      <mat-form-field appearance="outline">
        <mat-label>Project status</mat-label>
        <mat-select formControlName="status" required>
          <mat-option *ngFor="let status of statuses" [value]=status.id>
            {{status.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button *ngIf="highestRole.weight >= 1000" mat-button style="background: #7D44F4; color: white; width: 120px" (click)="changeStatus()">Confirm</button>
    </form> -->
  </div>
  <div style="border-top:1px solid rgba(222, 222, 222, 0.2);width: 100%;margin:24px 0"></div>


  <div style="padding-top: 20px;position: relative;">
    <h4 style="margin-top: 0">Who can view and manage this project?</h4>
    <div class="flex">
      <div>
        <div class="flex flex-wrap">
          <div class="flex flex-wrap" *ngIf="project && project.users && project.users.length > 0">
            <div class="text-center" *ngFor="let user of userList" style="min-width: 250px;margin: 0 0 10px 0;">
              <img src="../../../../../assets/images/default-user.svg" class="head-img" *ngIf="!user.headerUrl">
              <img src="{{SERVER_URL}}images{{user.headerUrl}}" class="head-img head-img-radius" *ngIf="user.headerUrl">
              <div class="text-overflow text-center fz_24 mt_20" style="height: 30px;">{{getUserName(user)}}</div>
              <div class="text-overflow text-center fz_16" style="margin-top: 6px;">{{getName(user)}}</div>

            </div>
            <div class="text-center" style="min-width: 250px;">
              <div class="add-btn ">
                <button (click)="openUserSelectionDialog($event)">
                  <ng-container>
                    <mat-icon style="font-size: 20px; height: 16px; width: 16px; margin-right: 5px;color: #DEDEDE;">add
                    </mat-icon>
                  </ng-container>
                </button>
              </div>
              <div style="color: rgba(222, 222, 222, 0.6);font-size:16px;margin-top: 24px;">Add another agent</div>
            </div>

          </div>

        </div>
      </div>

    </div>
    <div *ngIf="isMore&&this.project.users&&this.project.users.length > 5"
      style="position: absolute;bottom: 0px;right: 0px;cursor: pointer;border-bottom: #3C50E0 1px solid;color: #3C50E0;"
      (click)="viewMore()">View more</div>

    <div *ngIf="!isMore&&this.project.users&&this.project.users.length > 5"
      style="position: absolute;bottom: 0px;right: 0px;cursor: pointer;border-bottom: #3C50E0 1px solid;color: #3C50E0;"
      (click)="viewLess()">View less</div>
    <!-- <div style="display: flex; align-items: center;">
      <div *ngIf="project && project.users && project.users.length > 0">
        <p *ngFor="let user of project.users" style="color: #3C50E0; margin: 0 0 10px 0">
          {{getUserName(user)}}
        </p>
      </div>
    </div>
    <button mat-button style="background: #7D44F4; color: white; margin-top: 20px;width:120px" (click)="openUserSelectionDialog($event)"
            *ngIf="highestRole.weight >= 1000">{{project &&
    project.users && project.users.length > 0 ? 'Change' : 'Select'}}</button> -->
  </div>
  <div style="border-top:rgba(222, 222, 222, 0.2) 1px solid;width: 100%;margin:24px 0"></div>
  <div class="container" fxLayout="column" style="margin-top: 20px">
    <div class="panel" fxLayout="column" style="position: relative">
      <div *ngIf="this.project.status !== 1"
        style="color: #3C50E0; font-size: 24px;   position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.5); z-index: 2; display: flex; align-items: center; justify-content: center">
        The project is not enabled
      </div>
      <div class="panel-header">
        Display rules
      </div>
      <div class="button-group" fxLayout="row">
        <div class="button" fxFlex="50" fxLayout="row" fxLayoutGap="10px" (click)="handleTabIndexChange($event)"
          fxLayoutAlign="center center" style="cursor: pointer;background: #000;"
          [ngStyle]="{borderColor: tabIndex===0 ? 'rgba(222, 222, 222, 0.2)' : '#DEDEDE'}">
          <div [ngStyle]="{color: tabIndex===0 ? 'rgba(222, 222, 222, 0.2)' : '#DEDEDE'}" style="font-size: 14px">
            Display Group</div>
        </div>
        <div class="button" fxFlex="50" fxLayout="row" fxLayoutGap="10px" (click)="handleTabIndexChange($event)"
          fxLayoutAlign="center center" style="cursor: pointer;background: #000;"
          [ngStyle]="{borderColor: tabIndex===1 ? 'rgba(222, 222, 222, 0.2)' : '#DEDEDE'}">
          <div [ngStyle]="{color: tabIndex===1 ? 'rgba(222, 222, 222, 0.2)':'#DEDEDE'}" style="font-size: 14px">Custom
          </div>
        </div>
      </div>
      <div class="panel-content">
        <div *ngIf="tabIndex === 1" style="font-size: 14px;">
          <div class="left-btn" style="margin-top: 48px;">
            <div style="margin-right: 20px;">
              <button [value]="1" mat-button (click)="handleSave(1)" [disabled]="project.displayType == 1"
                [class]="{'disabled': project.displayType == 1}">Agencies and Customers</button>
              <div style="color: #505050;margin-top: 24px">All Customer from website and all agencies registered on
                Yephome are able to view this
                project</div>
            </div>
            <div>
              <button [value]="2" mat-button (click)="handleSave(2)" [disabled]="project.displayType == 2"
                [class]="{'disabled': project.displayType == 2}">Agencies Only</button>
              <div style="color: #505050;margin-top: 24px">All agencies registered on Yephome are able to view this
                project</div>

            </div>
          </div>
          <!-- <mat-radio-group [(ngModel)]="displayType" fxLayout="row">
            <div fxLayout="column">
              <mat-radio-button [checked]="this.projectDetail?.displayType === 1" [value]="1" color="primary" style="font-weight: bold;margin-bottom: 5px" fxLayout="column">
                Agencies and Customers
              </mat-radio-button>
              <div style="color: #505050;margin-left: 28px;margin-bottom: 15px">All Customer from website and all agencies registered on Yephome are able to view this
                project</div>
            </div>
            <div fxLayout="column">
              <mat-radio-button [checked]="this.projectDetail?.displayType === 2" [value]="2" color="primary" style="font-weight: bold;margin-bottom: 5px" fxLayout="column">
                Agencies Only
              </mat-radio-button>
              <div style="color: #505050;margin-left: 28px;margin-bottom: 15px">All agencies registered on Yephome are able to view this project</div>
            </div>
          </mat-radio-group> -->
        </div>
        <form class="form" *ngIf="tabIndex === 0" style="font-size: 14px" fxLayout="column">
          <!-- <div fxLayout="column" style="margin-bottom: 15px">
            <h3>Customers</h3>
            <mat-checkbox color="primary" (change)="handleCustomerCheck($event)"
              [checked]="displayType === 4 || displayType ===12">
              All Customer from website are able view this project
            </mat-checkbox>

            <h3>All Agents ({{totalElements}})</h3>
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom:16px">
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap=30px>
                <form (submit)="handleSubmit($event)">
                  <mat-form-field appearance="outline">
                    <mat-icon style="color: rgba(0, 0, 0, 0.54);margin-right: 15px">search</mat-icon>
                    <input class="search" matInput type="text" style="font-size: 14px"
                      placeholder="Search by Agency Name" [value]="searchInput"
                      (change)="searchInput = $event.target.value">
                  </mat-form-field>
                </form>
              </div>
              <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                <div>{{agentSelected}} Agent Selected</div>
                <mat-checkbox #showSelected color="primary">Show selected agent</mat-checkbox>
              </div>
            </div>
          </div> -->

          <div fxLayout="row" fxLayoutAlign="space-between center"
            style="padding: 10px 40px;  border-top-right-radius: 5px; border-top-left-radius: 5px;border: 1px solid rgba(27, 19, 75, 0.15);"
            class="agent-info" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex="30">
              <!-- <mat-checkbox color="primary" (change)="handleCheckAll($event)"></mat-checkbox> -->
              <!-- <span style="color: #C4C4C4">|</span> -->
              <div>Agency</div>
            </div>
            <span style="color: #C4C4C4">|</span>
            <div fxFlex="25">Email</div>
            <span style="color: #C4C4C4">|</span>
            <div fxFlex="10">Mobile</div>
            <span style="color: #C4C4C4">|</span>
            <div fxFlex="10">
              <mat-checkbox color="primary" (change)="handleCheckAll($event)"></mat-checkbox>
            </div>
          </div>
          <div fxLayout="column" class="table" style="max-height: 350px;overflow: auto;">
            <!-- <div>
              <div *ngFor="let eachAgency of selectedSales" fxLayout="row" fxLayoutAlign="space-between center"
                style="padding: 10px 40px;" class="agent-info" fxLayoutGap="20px"
                [style.padding-left]="matCheckbox?.checked ? '37px' : '40px'"
                [style.border-left]="matCheckbox?.checked ? '3px solid #293157': 'none'"
                [style.background]="matCheckbox?.checked ? '#000' : 'none'">
                <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex=30>
                  <img *ngIf="eachAgency.logo" src="{{SERVER_URL}}images/{{eachAgency.logo.fileName}}"
                    onerror="this.onerror=null;this.src='./assets/images/default-user.svg';"
                    style="width: 30px; height: 30px;border-radius: 50%;">
                  <img *ngIf="!eachAgency.logo" src="./assets/images/default-user.svg"
                    style="width: 30px; height: 30px">
                  <div>{{eachAgency.name}}</div>
                </div>
                <span style="color: transparent">|</span>
                <div fxFlex="25">{{eachAgency.email}}</div>
                <span style="color: transparent">|</span>
                <div fxFlex="10">{{eachAgency.phoneNumber}}</div>
                <span style="color: transparent">|</span>
                <div fxFlex="10">
                  <mat-checkbox #matCheckbox [checked]="isCheckboxChecked(eachAgency)"
                    (change)="handleChecked($event, eachAgency)" color="primary"></mat-checkbox>
                </div>
              </div>
            </div> -->
            <div>
              <div *ngFor="let eachAgency of allSalesArray; let i = index" fxLayout="row"
                fxLayoutAlign="space-between center" style="padding: 10px 40px;" class="agent-info" fxLayoutGap="20px"
                [class]="{
                    'checked-td': matCheckbox?.checked,
                    'checked-td-b-top': !allSalesArray[i - 1] || allSalesArray[i - 1]&&!isCheckboxChecked(allSalesArray[i - 1]),
                    'checked-td-b-bottom': !allSalesArray[i + 1] || allSalesArray[i + 1]&&!isCheckboxChecked(allSalesArray[i + 1]),
                    'checked-td-b-right': matCheckbox?.checked,
                    'checked-td-b-left': matCheckbox?.checked
                }">
                <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" fxFlex=30>
                  <img *ngIf="eachAgency.logo" src="{{SERVER_URL}}images/{{eachAgency.logo.fileName}}"
                    onerror="this.onerror=null;this.src='./assets/images/aspire.png';"
                    style="width: 30px; height: 30px;border-radius: 50%;">
                  <img *ngIf="!eachAgency.logo" src="./assets/images/aspire.png"
                    style="width: 30px; height: 30px;border-radius: 50%;">
                  <div>{{eachAgency.name}} {{i}}</div>
                </div>
                <span style="color: transparent">|</span>
                <div fxFlex="25">{{eachAgency.email}}</div>
                <span style="color: transparent">|</span>
                <div fxFlex="10">{{eachAgency.phoneNumber}}</div>
                <span style="color: transparent">|</span>
                <div fxFlex="10">
                  <mat-checkbox #matCheckbox [checked]="isCheckboxChecked(eachAgency)"
                    (change)="handleChecked($event, eachAgency)" color="primary" style="margin-left:
                    5px"></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            style="padding: 0 40px;  border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border: 1px solid rgba(27, 19, 75, 0.15);">
            <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions" (page)="getSalesByPage(pageSize, $event)">
            </mat-paginator>
          </div> -->
        </form>
        <div class=" flex justify-end mt_50" *ngIf="tabIndex!=1">
          <button mat-button class="update_button" (click)="handleUpdate()">
            Update
          </button>
        </div>
      </div>
    </div>
    <!-- <button mat-button fxFlexAlign="end" (click)="handleSave()"
      style="font-size: 14px;font-weight: 700;background: #000; width: 635px; height: 52px; color: #DEDEDE; margin-top: 40px; border-radius: 8px;border: 1px solid#DEDEDE;"
      ngStyle.lt-sm="width: 100%">
      Save
    </button> -->
  </div>


  <div style="border-top:#D9D9D9 1px solid;width: 100%;margin-top:24px"></div>
</div>